import api from '../../plugins/api';

// Прайс марки по приказу. Один прайс на марку, всегда открыт на редактирование —
// версий и копий нет. Семантика правил и корзин применения: doscar_back/docs/price-lists.md

// Марки, у которых есть сток приложения, — навигация по прайсам
export const getPriceMarks = () => api.get('/api/crm/prices/marks');

// Всё, что нужно экрану разом: шапка документа, правила, ветки стока, справочники
export const getPriceList = (markId) => api.get(`/api/crm/prices/${markId}`);

export const savePriceMeta = (markId, meta) => api.post(`/api/crm/prices/${markId}/meta`, meta);

// Правила уходят целиком: редактирование дерева локальное, экран присылает итоговый набор
export const savePriceRules = (markId, rules) => api.post(`/api/crm/prices/${markId}/rules`, rules);

// preview=true — посчитать и ничего не менять
export const applyPriceList = (markId, preview) =>
  api.post(`/api/crm/prices/${markId}/apply?preview=${preview ? 'true' : 'false'}`);

export const rollbackPriceList = (batchId) => api.post(`/api/crm/prices/rollback/${batchId}`);

export const getPriceHistory = (markId) => api.get(`/api/crm/prices/${markId}/history`);
